import { gql } from "@outschool/ui-apollo";

export default gql`
  fragment SavedSearchFragment on SavedSearch {
    uid
    createdAt
    filters {
      age
      capacityMax
      capacityMin
      delivery
      dow
      enabledBooleanFilters
      endBy
      endByTime
      format
      gradeLevel
      languageOfInstruction
      adminTags
      multiTermQuery
      order
      pricePerMeetingMax
      pricePerMeetingMin
      q
      startAfter
      startAfterTime
      startBefore
      theme
      time
      timeOfDay
      timeZone
      userUid
      userName
    }
  }
`;
